<af-main-container [title]="(isEdit ? 'i18n_af_editFaqTitle' : 'i18n_af_createFaqTitle') | translate: {id: this.faqId}"
                   [showBackButton]="true"
                   [tabPathToTab]="tabPathToTab"
                   [buttonSpinnerId]="'save'"
                   filterNavigationPath="edit-faq"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   (buttonClickListener)="save()">
    @if (form) {
        <form class="w-100 bc-mono-white radius-16 p-24 mt-24" [formGroup]="form"
              fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                <div fxLayout="column" fxLayoutAlign="start start" class="w-400">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelQuestionAuthor' | translate }}</div>
                    <mat-form-field class="mt-4 w-100">
                        <input matInput [value]="displayAuthor" readonly/>
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" class="w-400">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelQuestionCreatedDate' | translate }}</div>
                    <mat-form-field class="mt-4 w-100">
                        <input matInput [value]="displayCreatedDate | date:'dd.MM.yy HH:mm:ss'" readonly/>
                    </mat-form-field>
                </div>
            </div>

            <af-dictionary-selector class="w-400"
                                    [dictionaryName]="ReferenceBookType.FAQ_CATEGORY"
                                    [control]="form.controls.category"
                                    label="i18n_af_labelQuestionCategory"
                                    placeholder="i18n_af_placeholderCategory"/>

            <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelQuestion' | translate }}*</div>
                <mat-form-field class="mt-4 w-100"
                                [class.value-not-empty]="form.controls.question.value">
                <textarea matInput
                          #questionArea
                          [maxlength]="250"
                          class="resize-none pt-12 pb-12"
                          [placeholder]="'i18n_af_placeholderFaqQuestion' | translate"
                          [formControl]="form.controls.question"></textarea>
                    <mat-hint align="start" class="t5 c-primary-gray-600">
                        {{
                            'i18n_af_hintMaxLength' | translate: {
                                current: questionArea.value.length,
                                max: 250
                            }
                        }}
                    </mat-hint>
                </mat-form-field>
            </div>

            <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelAnswer' | translate }}*</div>
                <div class="editor-container height-auto custom-input mt-4 w-100" fxLayout="column"
                     [class.error]="form.controls.answer.hasError('maxLength')">
                    <ngx-editor-menu [editor]="editor" [toolbar]="NGX_EDITOR_DEFAULT_TOOLBAR"
                                     class="pl-16 pr-16 pt-16"></ngx-editor-menu>
                    <ngx-editor class="faq-editor" [editor]="editor"
                                [placeholder]="'i18n_af_placeholderFaqAnswer' | translate"
                                [formControl]="form.controls.answer">
                    </ngx-editor>
                </div>
                <div class="t5 c-primary-gray-600 mt-4"
                     [class.c-secondary-red-800]="form.controls.answer.hasError('maxLength')"> {{
                        'i18n_af_hintMaxLength' | translate: {
                            current: ngxEditorLength(),
                            max: DESCRIPTION_MAX_LENGTH
                        }
                    }}
                </div>
            </div>

            <ui-kit-checkbox [formControl]="form.controls.publish">
                {{ 'i18n_af_labelPublishQuestion' | translate }}
            </ui-kit-checkbox>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <ui-kit-button spinnerId="save"
                               [disabled]="form.invalid"
                               [label]="(isEdit ? 'i18n_af_buttonSave' : 'i18n_af_buttonAdd') | translate"
                               (clickListener)="save()"/>
                <ui-kit-button color="accent"
                               buttonType="button"
                               type="text"
                               (clickListener)="cancel()"
                               [label]="'i18n_af_buttonCancel' | translate"/>
            </div>
        </form>
    }
</af-main-container>
